import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { useRouter } from '@loyalup/core';

import { ReactComponent as LogoIcon } from 'icons/logo.svg';
import { ReactComponent as LogoTextIcon } from 'icons/logo_text.svg';

import s from './Sidebar.module.css';

const MenuItem = ({ className, to, text, icon, ...props }) => {
  const { NavLink } = useRouter();
  return (
    <NavLink className={cn(s.menuItem, className)} to={to} activeClassName={s.selectedItem} {...props}>
      {icon && <span className={s.icon}>{icon}</span>}
      <span className={s.text}>{text}</span>
    </NavLink>
  );
};

const MenuGroup = ({ icon, text, root, to, children }) => {
  const { useLocation } = useRouter();
  const location = useLocation();
  const isActive = location.pathname.match(`^${root}`);
  return (
    <div className={cn(s.groupContainer, { [s.selectedItem]: isActive })}>
      <MenuItem className={s.rootItem} to={to} text={text} icon={icon} isActive={() => isActive} />
      {<div className={cn(s.group)}>{children}</div>}
    </div>
  );
};

const Sidebar = ({ children, env }) => {
  const { Link } = useRouter();

  return (
    <nav className={s.root}>
      <Link className={s.logo} to="/">
        <LogoIcon className={s.logoIcon} width="28px" height="33px" />
        <LogoTextIcon width="67px" height="17px" />
        {env !== 'production' && <span className={s.env}>{env || 'dev'}</span>}
      </Link>
      {children}
    </nav>
  );
};

Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
};

Sidebar.MenuItem = MenuItem;
Sidebar.MenuGroup = MenuGroup;

export default Sidebar;
